import { Box, useTheme } from "@mui/material";
import BaseCard from "../../../theme/cards/BaseCard";
import Text from "../../../theme/text/Text";
import TopRight from "../../../theme/positionals/TopRight";
import ShLabel from "../../../theme/label/ShLabel";
import { tokens } from "../../../../theme";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { CheckBoxOutlineBlank } from "@mui/icons-material";
import CheckBox from "@mui/icons-material/CheckBox";
import { getInvoiceProductType, getInvoiceProductTypeLabel } from "../../../../utils/staticEnums";

export const WarehouseInvoiceProductCard = (props) => {
    
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t,i18n } = useTranslation();
    const color = props.isConcept ? "orange" : "green";

    // type and subType are two halves of one named type, shown as one label.
    const productType = getInvoiceProductType(props.type, props.subType);

    // State to hold the formatted date, label color, and label text
    const [labelColor, setLabelColor] = useState("grey");

    useEffect(() => {
        let iLabelColor = productType?.color ?? "grey";

        // keep your dark-mode override for "time"
        if (props.type === "time" && theme.palette.mode === "dark") {
            iLabelColor = "greyLight";
        }

        setLabelColor(iLabelColor);
    }, [props.type, props.subType, theme.palette.mode]);

    const handleToggle = (e) => {
        e.stopPropagation();
        e.preventDefault();
    //   setSelected(!selected);
        props.select(props.id);
    };

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick}>
            <Box>
                <Box
                    sx={{

                    }}
                >
                    {/* Top row */}
                    <Box
                        sx={{
                            display:"flex",
                            justifyContent:"space-between",
                            flexDirection:'column',
                        }}
                    >
                            <Text bold>{props.name}</Text>
                            <Text light>{props.invoiceline}</Text>
                        {/* <ShLabel borderless palette={"normal"} fitted size={32}>{formatPrice(i18n,props.totalPrice)}</ShLabel> */}
                    </Box>

                    <TopRight>
                        {props.canSelect &&
                            <Box 
                                onClick={handleToggle} 
                                sx={{ 
                                    borderTopRightRadius:12,
                                    borderBottomLeftRadius:12,
                                    borderTopLeftRadius:6,
                                    borderBottomRightRadius:6,
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    justifyContent:'center',
                                    cursor: 'pointer',
                                    width:40,
                                    height:32,
                                    background:theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100]
                                }}
                            >
                                {/* CheckBoxOutlineBlank for "No", CheckBox for "Yes" */}
                                {props.selected ? <CheckBox sx={{ fontSize: 24, fill: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400]}} /> : <CheckBoxOutlineBlank sx={{ fontSize: 24, color: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400] }} />}
                            </Box>
                        }
                    </TopRight>

                    <Box marginTop={3} display={"flex"} alignItems={"flex-start"} flexWrap={"wrap"} gap={1.5}>
                        <ShLabel variant={labelColor} fitted size={32}
                        
                            sx={{
                                whiteSpace:"nowrap",
                                wordBreak:"keep-all",
                                textOverflow:"ellipsis",
                                overflow:"hidden"
                            }}
                        >
                            {getInvoiceProductTypeLabel(t, props.type, props.subType)}
                        </ShLabel>
                        <ShLabel borderless fitted size={32}
                        
                            sx={{
                                whiteSpace:"nowrap",
                                wordBreak:"keep-all",
                                textOverflow:"ellipsis",
                                overflow:"hidden"
                            }}
                        >
                            #{t(props.ledger?.description)}
                        </ShLabel>
                    </Box>

                </Box>
            </Box>
        </BaseCard>
    )
}
